<template>
  <div class="bg">
    <div class="bigTitle" id="SyndicatedInsights">
      Our custom research and insights answer your biggest questions and support your business goals.
    </div>
    <div class="treatment" id="Treatment">
      <div class="title">Currently there are two public resources available which include </div>
      <div class="treatmentValue">
        <div class="value">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/IDI/IDI_box_1.png" alt="">
          <div class="text">
            <div>
              <div class="textTitle">Quantitative</div>
              <div class="textValue">Treatment Synopsis employs Holden’s HCP panel to understand the various treatment options (such as drugs used) in China, sorted by disease</div>
            </div>

          </div>
        </div>
        <div class="value">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/IDI/IDI_box_4.png" alt="">
          <div class="text">
            <div>
              <div class="textTitle">Qualitative</div>
              <div class="textValue">Patient Journey is a monthly release by HAT to provide an introductory understanding into patient touchpoints by disease</div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="report" id="Report">
      <div class="title">
        Learn more about our <span class="redHighLight">custom insights</span>
      </div>
      <div v-if="newsList.length>0" class="news">
        <div v-for="(item,idx) in newsList" :key="idx" class="contentInfo">
          <!-- <div class="contentInfo flexLeft odd" v-if="(idx+1)%2!=0"> -->
          <div>

            <img class="contentImg" :src="item.logo">
            <div class="flex1">
              <div class="tag" v-if="item.firstLabel">
                {{ item.firstLabel }}
              </div>
              <div class="contentTitle overflowMulityText2" v-html="item.newsTitle" style="color:#2cb1e9">
                {{ item.newsTitle }}
              </div>
              <div class="contents overflowMulityText3" v-html="item.newsDesc">
                {{ item.newsDesc }}
              </div>
              <div type="button" class="moreBtn" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
                READ MORE
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="contact">
      <div class="title">
        Is there a certain disease treatment that you are require insights on? We just might have what you need. So, contact us below.
      </div>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="First name" prop="firstname">
            <el-input v-model="ruleForm.firstname" @keyup.native="keyup" />
          </el-form-item>
          <el-form-item label="Last Name" prop="lastname">
            <el-input v-model="ruleForm.lastname" @keyup.native="keyup" />
          </el-form-item>
          <el-form-item label="Email" prop="mail">
            <el-input v-model="ruleForm.mail" @keyup.native="keyup" />
          </el-form-item>
          <el-form-item label="Phone number" prop="mobile">
            <el-input v-model="ruleForm.mobile" @keyup.native="keyup" />
          </el-form-item>
          <el-form-item label="Company Name" prop="companyName">
            <el-input v-model="ruleForm.companyName" @keyup.native="keyup" />
          </el-form-item>
          <el-form-item label="Job Title">
            <el-input v-model="ruleForm.position" @keyup.native="keyup" />
          </el-form-item>
          <el-form-item class="text" label="Type of study">
            <div class="type">(Please select all the studies you are interested in）</div>
            <el-checkbox-group v-model="checkList" @change="change">
              <div>
                <el-checkbox label="Healthcare"></el-checkbox>
                <el-checkbox label="Medtech"></el-checkbox>
                <el-checkbox label="Consumer"></el-checkbox>
              </div>
              <div>
                <el-checkbox label="Quantitative"></el-checkbox>
                <el-checkbox label="Qualitative"></el-checkbox>
              </div>
              <div>
                <el-checkbox label="Online survey"></el-checkbox>
                <el-checkbox label="Modeling & Analytics"></el-checkbox>
                <el-checkbox label="Programming & Processing"></el-checkbox>
                <el-checkbox label="Respondent Recruiting"></el-checkbox>
                <el-checkbox label="Bespoke Community Panel"></el-checkbox>
                <el-checkbox label="Product Placement Test"></el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="text" label="Message" prop="message">
            <el-input type="textarea" v-model="ruleForm.message" @keyup.native="keyup" />
          </el-form-item>

          <el-form-item prop="check" style="width:100%">
            <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;" class="checkyes">Yes, I would like to receive digital communications from Holden brands. I may opt-out of communications at any time using the unsubscribe link at the bottom of any email communication.</span>
          </el-form-item>
        </el-form>

        <div class="flexCenter">
          <div class="button" @click="submitForm('ruleForm')">
            SUBMIT
          </div>
        </div>
      </div>
    </div>
       <el-dialog title="" :visible="dialogVisible" width="30%">
      <span>Thank you for your interest in Holden! We have received your message. Our team will contact you soon.</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const defaultForm = {
  mail: "",
  firstname: "",
  lastname: "",
  mobile: "",
  position: "", //所属职位
  companyName: "", //公司名称
  interested: "",
  check: true,
  message: "" //留言
};
import { advertisementFlow, getNewsList, editConsultMail } from "@/api/api";

export default {
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      newsList: [],
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      dialogVisible:false,
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        companyName: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        message: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      }
    };
  },
  created() {
    this.$nextTick(() => {
      this.toLocal();
    });
    this.getNewsList();
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.ruleForm.fullName = _this.ruleForm.firstname + " " + _this.ruleForm.lastname;
          let ruleForm = {
            fullName: _this.ruleForm.fullName,
            mail: _this.ruleForm.mail,
            mobile: _this.ruleForm.mobile,
            position: _this.ruleForm.position,
            companyName: _this.ruleForm.companyName,
            message: _this.ruleForm.message,
            interested: _this.interested
          };
          this.checkList = [];
          editConsultMail(ruleForm).then(res => {
            // console.log(res);
            if (res.code == 10000) {
              _this.showTip = true;
              _this.tipStatus = true;
              _this.ruleForm = JSON.parse(JSON.stringify(defaultForm));
              this.dialogVisible = true;
            } else {
              _this.showTip = true;
              _this.tipStatus = false;
            }
          });
          return false;
        }
      });
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    toLocal() {
      //查找存储的锚点id
      let Id = localStorage.getItem("toId");
      let toElement = document.getElementById(Id);
      //锚点存在跳转
      if (Id) {
        toElement.scrollIntoView();
      }
    },
    toDetail(id, subscribe, newsTitle) {
      // 如果需要权限并且没有cookie
      if (subscribe == 1 && !this.$cookies.isKey("HoldenCookies")) {
        this.submitId = id;
        this.DialogShow = true;
        this.submitTitle = newsTitle;
      } else {
        this.$router.push({ name: "newsDetail", query: { id: id, source: "Syndicated Insights" } });
      }
    },
    getNewsList() {
      getNewsList({
        secondLabelId: "",
        firstLabelId: 27,
        pageSize: 0,
        othersLabel: this.$route.query.otherLabel,
        pageIndex: 1,
        status: 1, //启用
        origin: 1 //前台
      })
        .then(res => {
          if (res.code != 10000) {
            this.$message.error(res.msg || "Failed to query news information");
            return;
          }
          this.newsList = res.datalist;
        })
        .catch(error => {
          return;
        });
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "TreatmentSynopsis",
          source: "",
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "TreatmentSynopsis",
          source: this.$route.query.source,
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    }
  },
  destroyed() {
    localStorage.setItem("toId", "");
  }
};
</script>

<style scoped lang="scss">
* {
  font-family: "Nunito";
}
.bg {
  background-image: url(https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Background.png);
  background-size: cover;
  color: #1e364e;
  overflow: hidden;
}
.redHighLight {
  color: #e73323;
}
.blueHighLight {
  color: #4c8fd5;
}

.bigTitle {
  text-align: center;
  font-size: 60px;
  font-weight: 700;
  padding: 100px 200px;
  padding-bottom: 0;
}
.treatment {
  padding-top: 100px;
  .title {
    // padding: 0 200px;
    font-size: 40px;
    text-align: center;
  }
  .treatmentValue {
    display: flex;
    justify-content: space-between;
    padding: 50px;
    padding-bottom: 0;
    .value {
      width: 49%;
      position: relative;
      img {
        width: 100%;
      }
      .text {
        position: absolute;
        padding: 0 40px;
        top: 0;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        .textTitle {
          font-size: 40px;
          margin-bottom: 10px;
        }
        .textValue {
          font-size: 20px;
        }
      }
    }
  }
}
.report {
  padding-top: 100px;
  .title {
    font-size: 40px;
    text-align: center;
  }
  .news {
    display: flex;
    flex-wrap: wrap;
    padding: 0 100px;
    .contentInfo {
      width: 27%;
      // height: 480px;
      border: 1px solid #87c1e2;
      box-shadow: 4px 4px 4px 1px #c3ddec;
      border-radius: 3%;
      margin: 3%;
      position: relative;
      background: #ffffff;
      overflow: hidden;
      .tag {
        font-size: 12px;
        display: inline-block;
        padding: 0.7px 7.5px 2px;
        background: #e8f2ff;
        border-radius: 4px;
        color: #2186c8;
        font-size: 10px;
        margin-bottom: 10px;
      }

      .contentTitle {
        font-size: 18px;
        color: #333333;
        // line-height: 35px;
        font-weight: bold;
        min-height: 58px;
      }
      .contents {
        font-size: 13px;
        color: #333333;
        margin-top: 5px;
        text-align: justify;
        // line-height: 22px;
      }
      .moreBtn {
        // position: absolute;
        // bottom: 10px;
        margin-top: 30px;
        background: #217df6;
        font-size: 13px;
        color: #fff;
        border-radius: 7px;
        text-align: center;
        // width: 120px;
        // height: 39px;
        display: inline-block;
        padding: 0 20px;
        line-height: 39px;
        cursor: pointer;
        transition-delay: 0.1s;
        &:hover {
          background: #f5f5f5;
          color: #333333;
          transition-delay: 0.1s;
        }
      }
      .contentImg {
        width: 100%;
      }
      .flex1 {
        padding: 10px;
      }
    }
    @media screen and (max-width: 768px) and (min-width: 576px) {
      .contentInfo {
        width: 45%;
        // height: 700px;
        margin: 2.5%;
      }
    }
    @media screen and (max-width: 576px) {
      .contentInfo {
        width: 80%;
        // height: 950px;
        margin: 5% 10%;
      }
    }
  }
}
.contact {
  // width: 888px;
  margin: 0 auto;
  padding-bottom: 50px;
  .title {
    font-size: 40px;
    color: #1e364e;
    padding: 50px 200px;
    text-align: center;
  }
  .form {
    padding: 85px 63px;
    width: 888px;
    margin: 0 auto;
    background: #fff;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      /deep/ .el-form-item {
        display: inline-block;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        &:nth-child(even) {
          .el-form-item__label {
            margin-left: 7px;
          }
        }
        &:not(.text) {
          width: 50%;
        }
        &.text {
          width: 100%;
        }
        .el-form-item__content {
          flex: 1;
          .el-input {
            width: 238px !important;
          }
        }

        .el-form-item__label {
          width: 133px;
          font-size: 15px;
          display: block;
          font-weight: normal;
        }
        .el-textarea__inner {
          min-height: 104px !important;
        }
        .el-input__inner,
        .el-textarea__inner {
          // width: 250px;
          background: #fafafa;
          border: 1px solid #e6e6e6;
          border-radius: 7px;
          font-size: 15px;
        }
        .el-textarea__inner {
          width: 500px;
        }
        .el-form-item__error {
          font-size: 12px !important;
        }
      }
    }
    .button {
      margin-top: 17px;
      background: #217df6;
      font-size: 13px;
      color: #fff;
      border-radius: 7px;
      text-align: center;
      width: 91px;
      height: 34px;
      line-height: 34px;
      cursor: pointer;
    }
  }
}
</style>